import { useEffect } from 'react';

export default function ZohoHelpdesk() {
  useEffect(() => {
    // Inicialización requerida por Zoho
    window.$zoho = window.$zoho || {};
    window.$zoho.salesiq = window.$zoho.salesiq || { ready: function() {} };

    // Creación dinámica del tag <script> para cargar el widget
    const script = document.createElement('script');
    script.id = 'zsiqscript';
    script.src = 'https://salesiq.zohopublic.com/widget?wc=siq32d73721f9605474981c2edae2858130689b014c5714ca5754d35c5ed376294e';
    script.defer = true;

    document.body.appendChild(script);

    return () => {
      // Limpieza en caso de desmontar el componente para evitar duplicados
      const existingScript = document.getElementById('zsiqscript');
      if (existingScript && document.body.contains(existingScript)) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  return null; // Zoho inyecta su propio widget flotante en el body
}
